import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { CblcType } from '../../enum/clbc-type.enum';

@Component({
    selector: 'select-account',
    templateUrl: './select-account.component.html',
    styleUrls: ['./select-account.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAccount {

    @Input()
    public accounts: any[];

    @Output() public onCancel: EventEmitter<any> = new EventEmitter();

    @Output() public onSelect: EventEmitter<string> = new EventEmitter();

    public get personalAccounts() {
        return this.accounts
            .filter((a) => CblcType.Owner === a.CblcType);
    }

    public get otherAccounts() {
        return this.accounts.filter((a) => CblcType.Owner !== a.CblcType);
    }

    public selectAccount(code: string) {
        this.onSelect.emit(code);
    }

    public cancelAccountSelect() {
        this.onCancel.emit(true);
    }

}
